import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { THESS_SLIDES } from "../lib/content";
import { FadeUp, MaskReveal } from "./Reveal";

export default function CityShow() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % THESS_SLIDES.length), 4800);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      id="city"
      data-testid="city-section"
      className="relative h-[85vh] min-h-[560px] w-full overflow-hidden bg-[var(--bg)]"
    >
      {THESS_SLIDES.map((s, idx) => (
        <motion.div
          key={s.url}
          className="absolute inset-0"
          initial={false}
          animate={{ opacity: idx === i ? 1 : 0 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          <img
            src={s.url}
            alt={s.name}
            className={`h-full w-full object-cover ${idx % 2 ? "kenburns-2" : "kenburns"}`}
          />
        </motion.div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg)] via-[var(--bg)]/15 to-transparent" />

      <div className="relative z-10 flex h-full flex-col justify-end px-6 md:px-12 pb-14 md:pb-20 max-w-[1500px] mx-auto [text-shadow:0_1px_16px_rgba(233,243,252,0.6)]">
        <FadeUp className="mb-6 flex items-center gap-6">
          <span className="h-px w-12 bg-[var(--gold)]" />
          <span className="font-mono text-[11px] tracking-[0.35em] text-[var(--gold-ink)] uppercase">
            Η πόλη μας / Thessaloniki
          </span>
        </FadeUp>

        <h2 className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[1.02] text-[var(--fg)] max-w-3xl">
          <MaskReveal>Γεννημένοι στη</MaskReveal>
          <MaskReveal delay={0.08} className="italic text-[var(--gold-ink)]">
            Θεσσαλονίκη.
          </MaskReveal>
        </h2>

        <div className="mt-8 flex items-center gap-6">
          <div className="relative h-5 min-w-[240px]">
            <AnimatePresence mode="wait">
              <motion.span
                key={i}
                data-testid="city-slide-name"
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.5 }}
                className="absolute left-0 top-0 font-mono text-sm tracking-[0.2em] text-[var(--fg)]"
              >
                {THESS_SLIDES[i].name}
              </motion.span>
            </AnimatePresence>
          </div>
          <div className="flex gap-2">
            {THESS_SLIDES.map((_, idx) => (
              <button
                key={idx}
                data-testid={`city-dot-${idx}`}
                onClick={() => setI(idx)}
                aria-label={`Θέα ${idx + 1}`}
                className={`h-1.5 rounded-full transition-[width,background-color] duration-500 ${
                  idx === i ? "w-8 bg-[var(--gold)]" : "w-3 bg-[var(--fg)]/30 hover:bg-[var(--fg)]/60"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
